import React from 'react'
import { createPortal } from 'react-dom'
import useConfirm from '../hooks/Dialog'

export function Dialog() {
  const { onConfirm, onCancel, confirmState } = useConfirm()
  const portalElement = document.getElementById('portal')
  const component = confirmState.show ? (
    <>
      <div className="modal fade show">
        <div className="modal-dialog modal-dialog-centered">
          <div className="modal-content">
            <div className="modal-header">{confirmState?.title && confirmState.title}</div>
            <div className="modal-body">
              <div>{confirmState?.text && confirmState.text}</div>
            </div>
            <div className="modal-footer">
              {confirmState.canCancel && <div className="btn" onClick={onCancel}>Cancel</div>}
              <div className="btn btn-primary" onClick={onConfirm}>OK</div>
            </div>
          </div>
        </div>
      </div>
      <div className="modal-backdrop fade show"></div>
    </>
  ) : null;
  return createPortal(component, portalElement)
}